export const inviteMembersLabels = {
  title: 'Invite Team Members (optional)',
  subtitle: 'Members will receive an invitation to join your team.',
  ctaButton: 'Finish',
  inputPlaceholder: 'Enter emails',
};
